import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="page-mentions-legales">
      <div className="bg-gradient-to-br from-[#0F172A] via-[#1B3A6B] to-[#0F172A] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
          <Link to="/" className="inline-flex items-center gap-2 text-slate-300 hover:text-white text-sm mb-6" data-testid="mentions-back-home">
            <ArrowLeft className="w-4 h-4" /> Retour à l'accueil
          </Link>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 text-xs font-medium mb-4">
            <ShieldCheck className="w-3.5 h-3.5 text-[#FBBF24]" />
            Transparence & conformité
          </div>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">
            Mentions légales <span className="text-[#FBBF24]">& politique RGPD</span>
          </h1>
          <p className="mt-4 text-slate-300 text-sm">Dernière mise à jour : février 2026</p>
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <article className="prose prose-slate max-w-none bg-white rounded-3xl border border-slate-200 shadow-sm p-6 sm:p-10 space-y-8">
          <section>
            <h2 className="font-display text-2xl font-bold text-slate-900 tracking-tight">Éditeur du site</h2>
            <div className="mt-3 text-sm text-slate-700 leading-relaxed space-y-1">
              <p><strong>INGélec</strong> — Entreprise individuelle (microentreprise)</p>
              <p>Siège social : Sainte-Suzanne, 97441 — Île de La Réunion</p>
              <p>Email : <a className="text-[#1B3A6B] underline" href="mailto:contact@ingelec.re">contact@ingelec.re</a></p>
              <p>Téléphone : <a className="text-[#1B3A6B] underline" href="tel:+262692371331">0692 37 13 31</a></p>
              <p>Directeur de la publication : Le gérant d'INGélec</p>
            </div>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-slate-900 tracking-tight">Hébergement</h2>
            <div className="mt-3 text-sm text-slate-700 leading-relaxed space-y-1">
              <p>
                <strong>LWS</strong> — Ligne Web Services SARL<br />
                10 rue Penthièvre, 75008 Paris — France<br />
                <a className="text-[#1B3A6B] underline" href="https://www.lws.fr" target="_blank" rel="noreferrer">www.lws.fr</a>
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-slate-900 tracking-tight">Propriété intellectuelle</h2>
            <p className="mt-3 text-sm text-slate-700 leading-relaxed">
              L'ensemble du contenu de ce site (textes, images, logos, photos de chantiers, graphismes, structure)
              est la propriété exclusive d'INGélec ou de ses partenaires. Toute reproduction, représentation, modification
              ou exploitation, totale ou partielle, par quelque procédé que ce soit, sans autorisation écrite préalable,
              est strictement interdite et constituerait une contrefaçon sanctionnée par les articles L.335-2 et suivants
              du Code de la propriété intellectuelle.
            </p>
            <p className="mt-3 text-sm text-slate-700 leading-relaxed">
              Les marques et logos tiers (Schneider Electric, Legrand, Wallbox, Qualifelec, IRVE, etc.) sont la
              propriété de leurs détenteurs respectifs et sont affichés avec leur accord ou à titre informatif.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-slate-900 tracking-tight">Protection des données personnelles (RGPD)</h2>
            <p className="mt-3 text-sm text-slate-700 leading-relaxed">
              Conformément au Règlement Général sur la Protection des Données (RGPD — règlement UE 2016/679) et à la
              loi Informatique et Libertés modifiée, INGélec, en qualité de responsable du traitement, s'engage à
              protéger la vie privée des utilisateurs de ce site.
            </p>

            <h3 className="mt-5 font-semibold text-slate-900">Données collectées</h3>
            <ul className="mt-2 text-sm text-slate-700 leading-relaxed list-disc ml-5 space-y-1">
              <li><strong>Formulaire de contact :</strong> nom, email, téléphone, ville, activité souhaitée, message.</li>
              <li><strong>Inscription à la newsletter :</strong> email, prénom (optionnel), centres d'intérêt.</li>
            </ul>

            <h3 className="mt-5 font-semibold text-slate-900">Finalités</h3>
            <ul className="mt-2 text-sm text-slate-700 leading-relaxed list-disc ml-5 space-y-1">
              <li>Répondre à vos demandes de devis et d'information.</li>
              <li>Vous envoyer, avec votre consentement explicite, des actualités liées à nos activités.</li>
              <li>Améliorer la qualité de nos services.</li>
            </ul>

            <h3 className="mt-5 font-semibold text-slate-900">Base légale</h3>
            <p className="mt-2 text-sm text-slate-700 leading-relaxed">
              Consentement (art. 6.1.a RGPD) pour la newsletter — intérêt légitime et mesures précontractuelles
              (art. 6.1.b et 6.1.f) pour le traitement des demandes de contact.
            </p>

            <h3 className="mt-5 font-semibold text-slate-900">Durée de conservation</h3>
            <ul className="mt-2 text-sm text-slate-700 leading-relaxed list-disc ml-5 space-y-1">
              <li>Demandes de contact : 3 ans après le dernier échange.</li>
              <li>Inscription newsletter : jusqu'à votre désinscription.</li>
            </ul>

            <h3 className="mt-5 font-semibold text-slate-900">Vos droits</h3>
            <p className="mt-2 text-sm text-slate-700 leading-relaxed">
              Vous disposez d'un droit d'accès, de rectification, d'effacement, d'opposition, à la portabilité
              et à la limitation du traitement de vos données. Pour exercer ces droits ou pour toute question
              relative à vos données personnelles, contactez-nous à{" "}
              <a className="text-[#1B3A6B] underline" href="mailto:contact@ingelec.re">contact@ingelec.re</a>.
            </p>
            <p className="mt-2 text-sm text-slate-700 leading-relaxed">
              Pour la newsletter, vous pouvez vous désinscrire à tout moment via le lien présent dans chaque email,
              ou directement sur la page{" "}
              <Link to="/desinscription" className="text-[#1B3A6B] underline">/desinscription</Link>.
            </p>
            <p className="mt-2 text-sm text-slate-700 leading-relaxed">
              En cas de litige, vous pouvez introduire une réclamation auprès de la CNIL :{" "}
              <a className="text-[#1B3A6B] underline" href="https://www.cnil.fr/fr/plaintes" target="_blank" rel="noreferrer">www.cnil.fr/fr/plaintes</a>.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-slate-900 tracking-tight">Sous-traitants</h2>
            <p className="mt-3 text-sm text-slate-700 leading-relaxed">
              Pour fournir ses services en ligne, INGélec recourt aux sous-traitants suivants, qui agissent dans le
              strict respect du RGPD :
            </p>
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-3">
              <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
                <div className="font-semibold text-slate-900">Brevo</div>
                <div className="text-xs text-slate-600 mt-1 leading-relaxed">
                  Routage de la newsletter (emails marketing).<br />
                  <span className="text-slate-500">Siège : France · Hébergement UE</span>
                </div>
                <a href="https://www.brevo.com/fr/legal/privacypolicy/" target="_blank" rel="noreferrer" className="mt-2 inline-block text-xs text-[#1B3A6B] underline">Politique de confidentialité</a>
              </div>
              <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
                <div className="font-semibold text-slate-900">Resend</div>
                <div className="text-xs text-slate-600 mt-1 leading-relaxed">
                  Envoi des emails transactionnels (demandes de contact).<br />
                  <span className="text-slate-500">Hébergement : États-Unis (Standard Contractual Clauses)</span>
                </div>
                <a href="https://resend.com/legal/privacy-policy" target="_blank" rel="noreferrer" className="mt-2 inline-block text-xs text-[#1B3A6B] underline">Politique de confidentialité</a>
              </div>
              <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
                <div className="font-semibold text-slate-900">Cloudinary</div>
                <div className="text-xs text-slate-600 mt-1 leading-relaxed">
                  Hébergement des images du catalogue et des réalisations.<br />
                  <span className="text-slate-500">Hébergement : États-Unis (SCC)</span>
                </div>
                <a href="https://cloudinary.com/privacy" target="_blank" rel="noreferrer" className="mt-2 inline-block text-xs text-[#1B3A6B] underline">Politique de confidentialité</a>
              </div>
            </div>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-slate-900 tracking-tight">Cookies & traceurs</h2>
            <p className="mt-3 text-sm text-slate-700 leading-relaxed">
              Ce site utilise uniquement des cookies strictement nécessaires au fonctionnement (session de connexion
              administrateur) et n'utilise aucun traceur publicitaire ni outil d'analyse comportementale.
            </p>
            <p className="mt-2 text-sm text-slate-700 leading-relaxed">
              Si vous consultez le flux Facebook intégré sur la page d'accueil, Facebook peut déposer ses propres
              cookies — pour plus d'informations, consultez la{" "}
              <a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noreferrer" className="text-[#1B3A6B] underline">politique de confidentialité de Meta/Facebook</a>.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-slate-900 tracking-tight">Limitation de responsabilité</h2>
            <p className="mt-3 text-sm text-slate-700 leading-relaxed">
              INGélec s'efforce de fournir des informations aussi précises que possible, mais ne peut garantir
              l'exhaustivité ou l'actualité de l'ensemble des informations présentées. Les photos de chantiers sont
              publiées avec l'accord des clients concernés. Les prix et disponibilités du catalogue de location sont
              indicatifs et peuvent évoluer sans préavis — un devis officiel sera systématiquement émis avant toute
              prestation.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-slate-900 tracking-tight">Droit applicable</h2>
            <p className="mt-3 text-sm text-slate-700 leading-relaxed">
              Les présentes mentions légales sont régies par le droit français. Tout litige relatif à l'utilisation
              de ce site relève de la compétence exclusive des tribunaux français.
            </p>
          </section>
        </article>
      </main>
    </div>
  );
}
